import React, { useState, useEffect, useCallback } from 'react';
import { api } from '../../services/api';

// Partnership Management - Schools (User Management CSS) — real data from approved school partners
const SchoolsTab = () => {
  const [schools, setSchools] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [search, setSearch] = useState('');

  const fetchSchools = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const params = new URLSearchParams();
      if (statusFilter === 'active' || statusFilter === 'disabled') params.set('status', statusFilter);
      const res = await api.get(`/api/admin/partner-requests/schools?${params.toString()}`);
      const data = res?.data?.data ?? res?.data ?? [];
      setSchools(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err?.response?.data?.message || err?.message || 'Failed to load schools');
      setSchools([]);
    } finally {
      setLoading(false);
    }
  }, [statusFilter]);

  useEffect(() => {
    fetchSchools();
  }, [fetchSchools]);

  const filteredSchools = search.trim()
    ? schools.filter((s) => {
        const q = search.trim().toLowerCase();
        return (
          (s.schoolName || '').toLowerCase().includes(q) ||
          (s.email || '').toLowerCase().includes(q) ||
          (s.name || '').toLowerCase().includes(q)
        );
      })
    : schools;

  const formatCurrency = (n) => {
    const num = Number(n);
    if (Number.isNaN(num)) return '—';
    // Manual payments are currently in DA for schools
    return `${Math.round(num).toLocaleString()} DA`;
  };

  return (
    <div className="tab-content">
      <div className="user-controls">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search schools"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <span className="material-icons">search</span>
        </div>
        <select
          className="partnership-filter-select"
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
        >
          <option value="all">All Statuses</option>
          <option value="active">Active</option>
          <option value="disabled">Disabled</option>
        </select>
      </div>

      {error && (
        <div className="error-message" style={{ marginBottom: 16 }}>
          <span className="material-icons">error</span> {error}
        </div>
      )}

      {loading ? (
        <p style={{ padding: 24, textAlign: 'center' }}>Loading partners…</p>
      ) : (
        <table className="users-table">
          <thead>
            <tr>
              <th>Organization</th>
              <th>Country</th>
              <th>Students Referred</th>
              <th>Manual Payments</th>
              <th>Commissions</th>
              <th>Total Revenue</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredSchools.length === 0 ? (
              <tr>
                <td colSpan={8} style={{ textAlign: 'center', padding: 24 }}>
                  {schools.length === 0
                    ? 'No partners yet. Approved school and education partner requests will appear here.'
                    : 'No partners match your search.'}
                </td>
              </tr>
            ) : (
              filteredSchools.map((school) => (
                <tr key={school.id}>
                  <td>{school.schoolName || school.name || '—'}</td>
                  <td>—</td>
                  <td>{school.studentsReferred ?? 0}</td>
                  <td>{formatCurrency(school.revenueManualPayments)}</td>
                  <td>{formatCurrency(school.revenueCommissions)}</td>
                  <td>{formatCurrency(school.revenueGenerated)}</td>
                  <td>{school.status === 'active' ? 'Active' : 'Disabled'}</td>
                  <td>
                    <div className="action-buttons">
                      <a href={`mailto:${school.email || ''}`} className="action-btn edit">Contact</a>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default SchoolsTab;
